var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "magic_nav_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v("选择样式")]),
      _c(
        "el-form-item",
        {
          staticClass: "magic_type",
          attrs: {
            prop: "magic_type",
            rules: [
              {
                required: true,
                message: "请先选择一种样式",
                trigger: "change",
              },
            ],
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.defaultList, function (item) {
              return _c(
                "div",
                {
                  key: item.magic_type,
                  class: [
                    "box",
                    item.magic_type == _vm.value.config.magic_type && "checked",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeMagicType(item)
                    },
                  },
                },
                [
                  _c("el-image", {
                    staticClass: "img",
                    attrs: { fit: "contain", src: item.imageurl },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      ["6", "7"].includes(_vm.value.config.magic_type)
        ? _c(
            "el-form-item",
            { attrs: { prop: "is_show_shadow" } },
            [
              _c("div", { staticClass: "label" }, [_vm._v("设置边框阴影")]),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.value.config.is_show_shadow,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "is_show_shadow", $$v)
                    },
                    expression: "value.config.is_show_shadow",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("展示阴影")]),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("隐藏阴影")]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "title" }, [
        _vm._v(" 设置图片及菜单 "),
        ["6", "8"].includes(_vm.value.config.magic_type)
          ? _c("span", { staticClass: "tips" }, [
              _vm._v(" 图片高度建议保持一致 "),
            ])
          : _vm._e(),
      ]),
      _vm._l(_vm.value.config.value, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "menuBox" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.getMagicTitle(_vm.value.config.magic_type, index, 0)
                  ) +
                  " "
              ),
            ]),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "value." + index + ".imageurl",
                  rules: [
                    {
                      required: true,
                      message:
                        _vm.getMagicTitle(
                          _vm.value.config.magic_type,
                          index,
                          0
                        ) + "不可为空",
                      trigger: "change",
                    },
                  ],
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "upload-item-wrap" },
                  [
                    _c("upload-file", {
                      ref: "uploadBanner" + index,
                      refInFor: true,
                      attrs: {
                        "link-url": _vm.linkUrl,
                        tempurl: item.imageurl,
                        canDel: Boolean(item.imageurl),
                        deletePadding: true,
                        uploadInfo: _vm.uploadInfo,
                      },
                      on: {
                        onDelete: function ($event) {
                          return _vm.onDelete(item)
                        },
                        emitUploadFile: function (res) {
                          return _vm.emitUploadFile(res, item, "imageurl")
                        },
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.onUpload(index)
                              },
                            },
                          },
                          [_vm._v("上传图片")]
                        ),
                        _vm.pictureInfo[index + 1]
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectPicture(index)
                                  },
                                },
                              },
                              [_vm._v(" 选择图片 ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "tips" },
                  [
                    ["6", "8"].includes(_vm.value.config.magic_type)
                      ? [
                          _vm._v(
                            " 建议宽度：" +
                              _vm._s(
                                _vm
                                  .getMagicTitle(
                                    _vm.value.config.magic_type,
                                    index,
                                    1
                                  )
                                  .split("*")[0]
                              ) +
                              "px，高度等比例展示，支持JPG、PNG，大小不超过2M "
                          ),
                        ]
                      : [
                          _vm._v(
                            " 建议尺寸为" +
                              _vm._s(
                                _vm.getMagicTitle(
                                  _vm.value.config.magic_type,
                                  index,
                                  1
                                )
                              ) +
                              "，支持JPG、PNG等格式，大小不超过2M"
                          ),
                        ],
                  ],
                  2
                ),
              ]
            ),
            _c("config-menu", {
              attrs: {
                value: item,
                type: _vm.value.key,
                index: index,
                info: _vm.info,
                menuList: _vm.menuList,
                childrenMenuList: _vm.childrenMenuList,
                customerModuleList: _vm.customerModuleList,
                eBookCategoryList: _vm.eBookCategoryList,
                aBookCategoryList: _vm.aBookCategoryList,
                customerPackageList: _vm.customerPackageList,
                systemMenus: _vm.systemMenus,
              },
            }),
          ],
          1
        )
      }),
      _c(
        "el-form-item",
        { attrs: { prop: "prompt_content" } },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v("卡规则不支持时提示文案"),
          ]),
          _c("el-input", {
            attrs: { placeholder: "请输入", clearable: "" },
            model: {
              value: _vm.value.config.prompt_content,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "prompt_content", $$v)
              },
              expression: "value.config.prompt_content",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              pictureIndex: _vm.pictureIndex,
              depot: _vm.depot,
              subhead: _vm.getMagicTitle(
                _vm.value.config.magic_type,
                _vm.updateIndex,
                0
              ),
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }